module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer-wrapper"
  }, [(!_vm.$session.loading && !(_vm.$session.user && _vm.$session.user.username) && this.$route.name === 'Landing') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": 300,
      "name": "appfade"
    }
  }, [(_vm.$session.loading) ? _c('div', {
    staticClass: "main-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": 1000,
      "name": "applogin"
    }
  }, [(!(_vm.$session.user && _vm.$session.user.username && _vm.$session.jwtExpiration) && (this.$route.name !== 'Landing' || (this.$route.name === 'Landing' && _vm.$session.showLogin))) ? _c('login') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": 1000,
      "name": "appfade"
    }
  }, [(_vm.$session.user && _vm.$session.user.username) ? _c('div', {
    staticClass: "app"
  }, [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "app-footer"
  }, [_vm._v("\n        Test Stand Portal © 2017 Highlight Industries.\n      ")])], 1) : _vm._e()]), _vm._v(" "), _c('modal-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43dc71c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 733
// module chunks = 8